import type { RecommendationSelectButtonProps } from "./recommendation-select-button.type";

import { Form } from "antd";
import { useTranslation } from "react-i18next";

import { RecommendationSelect } from "@/modules/recommendation/recommendation-select";

import { useSelectRecommendation } from "./recommendation-select-button.hook";

const RecommendationSelectButton = ({
  interventionId,
  observationId,
  disabled,
}: RecommendationSelectButtonProps) => {
  const { t } = useTranslation();
  const { onSelectChange } = useSelectRecommendation({ observationId });

  return (
    <Form>
      <RecommendationSelect
        allowClear
        hideLabel
        placeholder={t("recommendation:select.placeholder")}
        emptyPlaceholder={t("recommendation:select.emptyPlaceholder")}
        additionalFilters={{ "filter[source_intervention]": interventionId }}
        onChange={onSelectChange}
        disabled={disabled}
        disabledOnEmpty
      />
    </Form>
  );
};

export default RecommendationSelectButton;
